import {LanguageContentBase,LanguageContentKeyBase,ComponentLanguageContentBase,} from '@app/database-models'
//Generated Imports
export class LanguageContent extends LanguageContentBase 
{




//#region Generated Reference Properties
//#region languageContentKey Prop
languageContentKey : LanguageContentKeyBase;
//#endregion languageContentKey Prop
//#region componentLanguageContents Prop
componentLanguageContents : ComponentLanguageContentBase[];
//#endregion componentLanguageContents Prop

//#endregion Generated Reference Properties


























}